import classNames from "lib/classNames";
import React, { useContext, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import ShopContext from "context/ShopContext";
import Lottie from "react-lottie";
import animationData from "lib/rocket-animation.json";
import { UPDATE_SHOP_PROP } from "lib/mutations";
import { Button, Dropdown, Icon } from "components";
import { Redirect } from "@shopify/app-bridge/actions";
import EmbeddedContext from "context/EmbeddedContext";

export default function ({ setItem }) {
    const { state } = useContext(ShopContext);
    const { static_file_status, static_file_mode } = state;
    const isProcessing = static_file_status === "processing"
    const isCompleted = static_file_status === "completed"
    // const [mode, setMode] = useState(static_file_mode || "test");
    const [loading, setLoading] = useState(false);
    const activateStaticGenerator = async ({ disable = false, mode = "test" } = {}) => {
        try {
            setLoading(disable ? "disable" : "save");
            const { status, mode: response_mode } = await API.post(
                "API_GATEWAY_NEW",
                "/static_generator/activate",
                {
                    body: {
                        mode,
                        disable
                    }
                }
            );
            setItem("static_file_status", status)
            setItem("static_file_mode", response_mode)
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };
    const GoTest = () => {
        return activateStaticGenerator({ mode: "test" })
    }
    const GoLive = () => {
        return activateStaticGenerator({ mode: "live" })
    }
    const Disable = () => {
        return activateStaticGenerator({ disable: true })
    }
    return (
        <div
            className={classNames(
                "flex items-center bg-blue-100 rounded shadow my-5 p-3"
            )}
        >
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice"
                    }
                }}
                height={180}
                width={180}
            />
            <div className={classNames("flex-1 pl-3")}>
                <h4 className={classNames("text-xl font-bold text-gray-700 mb-3")}>
                    Congratulations, you are eligible for the ⚡Lightning speed
                    integration
                </h4>
                <p className={classNames("leading-loose")}>
                    The Lightning Speed Integration is 10x faster than the current
                    integration, Start by selecting the test mode and click activate.
                </p>
                <a href="#" className={classNames("font-bold underline text-gray-700 text-sm")}>Learn more about this integration</a>
                <div className={classNames("flex justify-end mt-3")}>
                    {isProcessing && <div className={classNames("text-gray-600 text-sm")}>
                        <Icon spin={true} size="sm" icon="spinner-third" className="mr-2" /> Processing
                    </div>}
                    {!isProcessing && !isCompleted && <Activate loading={loading} GoTest={GoTest} />}
                    {!isProcessing && isCompleted && static_file_mode === "test" && <TestMode loading={loading} GoLive={GoLive} />}
                    {!isProcessing && isCompleted && static_file_mode === "live" && <LiveMode loading={loading} Disable={Disable} GoTest={GoTest} />}
                </div>
            </div>
        </div>
    );
}

function Activate ({ loading, GoTest }) {
    return <Button
        text="Install"
        onClick={GoTest}
        loading={loading === "save"}
    />
}

function TestMode ({ GoLive, loading }) {
    const { AppBridgeRedirect } = useContext(EmbeddedContext);
    const { state: { id } } = useContext(ShopContext);
    return <>
        <Button
            text="Preview Speed Cart"
            type="secondary"
            className={classNames("mr-2")}
            onClick={() => {
                AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, {
                    url: `https://${id}`, newContext: true
                });
            }}
        />
        <Button
            text="Go Live"
            onClick={GoLive}
            loading={loading === "save"}
        />
    </>
}
function LiveMode ({ GoTest, Disable, loading }) {
    return <>
        <Button
            text="Disable"
            type="secondary"
            className={classNames("mr-2")}
            onClick={Disable}
            loading={loading === "disable"}
        />
        <Button
            text="Return to preview mode"
            onClick={GoTest}
            loading={loading === "save"}
        />
    </>
}